import { Link } from "react-router-dom";
import {
  ArrowRight, Check, QrCode, Globe2, BadgeCheck, Award, Camera, Video, Compass, Megaphone,
  Link2, Eye, Search, UserCheck, ShoppingCart, HandCoins, Landmark, Truck, Handshake, Target,
  Users, TrendingUp, ShieldCheck, Mail, Globe, Building2, Sparkles,
} from "lucide-react";
import { QRPattern } from "../components/kit";

const CERT_POINTS = ["Digital Membership Certificate", "Unique Membership ID", "Verification QR Code", "Global Recognition", "Trust, Credibility & Visibility"];
const PROFILE_POINTS = ["Professional Company Profile", "Products, Services & Capabilities", "Business Information & Highlights", "Photos, Videos & 360° Virtual Tour", "What You Are Looking For", "Showcase Your Strengths", "Build Trust & Credibility"];
const WEBSITE_POINTS = ["Add your official website", "Increase visibility & trust", "Drive more business inquiries", "Strengthen global presence", "Get discovered by the right people"];
const WHY_IT_MATTERS = ["Global Visibility", "Verified & Trusted Network", "More Business Opportunities", "Stronger Connections", "Endless Growth"];
const DISCOVERY_TILES = [
  [UserCheck, "BUYERS"], [ShoppingCart, "SELLERS"], [HandCoins, "INVESTORS"], [Landmark, "LENDERS"],
  [Truck, "SUPPLIERS"], [Handshake, "PARTNERS"], [Target, "OPPORTUNITIES"],
];
const BOTTOM_STRIP = [
  [ShieldCheck, "VERIFIED", "Verified members build a trusted global ecosystem."],
  [Users, "CONNECTED", "Connect with the right businesses across industries."],
  [Target, "OPPORTUNITIES", "Access opportunities that drive growth and success."],
  [TrendingUp, "GROW TOGETHER", "Stronger together. Smarter together. Grow together."],
];

function NumberBadge({ n }) {
  return <span className="font-display font-black text-4xl md:text-5xl text-gold leading-none shrink-0">{n}</span>;
}

function Checklist({ items, testid }) {
  return (
    <ul className="space-y-3" data-testid={testid}>
      {items.map((x) => (
        <li key={x} className="flex items-start gap-2.5 text-sm text-slate-200">
          <Check size={15} className="text-gold shrink-0 mt-0.5" strokeWidth={3} />{x}
        </li>
      ))}
    </ul>
  );
}

function CertificateMock() {
  return (
    <div className="relative bg-[#FBF6E9] text-navy-900 rounded-sm p-1.5 shadow-2xl shadow-gold/10 rotate-1 hover:rotate-0 transition-transform" data-testid="certificate-mock">
      <div className="border-2 border-gold-muted rounded-sm p-6 md:p-8 text-center relative">
        <p className="font-display font-black text-xl tracking-tight"><span className="text-[#B08D1E]">10X</span>GLOBAL</p>
        <p className="text-[8px] font-mono tracking-[0.3em] text-slate-500 mt-0.5">ADVISORY</p>
        <div className="w-16 h-px bg-gold-muted mx-auto my-4" />
        <p className="text-xs font-bold tracking-[0.2em] text-slate-800">MEMBERSHIP CERTIFICATE</p>
        <p className="text-[9px] italic text-slate-500 mt-3">This is to certify that</p>
        <p className="font-display font-bold text-base text-slate-900 mt-1">YOUR COMPANY NAME</p>
        <p className="text-[9px] text-slate-500 mt-1">is an Official Member of 10XGLOBAL Advisory</p>
        <div className="flex items-end justify-between mt-6 text-[8px] font-mono text-slate-600">
          <div className="text-left"><p>Member ID : 10XG-XXXXXX</p><p className="mt-0.5">Valid Till : DD/MM/YYYY</p></div>
          <QRPattern size={44} testid="certificate-qr" />
        </div>
        <div className="absolute right-6 bottom-14 w-12 h-12 rounded-full bg-gold/90 flex items-center justify-center shadow-md">
          <Award size={22} className="text-navy-950" />
        </div>
      </div>
    </div>
  );
}

function DeviceMocks() {
  return (
    <div className="flex items-end gap-4" data-testid="device-mocks">
      <div className="flex-1 bg-navy-900 border border-slate-700 rounded-md overflow-hidden shadow-2xl">
        <div className="flex items-center gap-1.5 px-3 py-2 border-b border-slate-800">
          <span className="w-2 h-2 rounded-full bg-slate-700" /><span className="w-2 h-2 rounded-full bg-slate-700" /><span className="w-2 h-2 rounded-full bg-slate-700" />
          <span className="ml-2 flex-1 bg-navy-800 rounded-sm px-2 py-0.5 text-[8px] font-mono text-slate-500">10x-global.com/yourcompany</span>
        </div>
        <div className="p-4">
          <div className="h-16 rounded-sm bg-gradient-to-r from-navy-700 to-navy-800 border border-slate-700 flex items-center px-4 gap-3">
            <span className="w-9 h-9 rounded-sm bg-gold flex items-center justify-center font-display font-black text-navy-950 text-xs">YC</span>
            <div><p className="text-xs font-bold text-slate-100">YOUR COMPANY NAME</p><p className="text-[8px] text-slate-400">Driving Innovation. Delivering Value.</p></div>
          </div>
          <div className="flex gap-2 mt-2.5">{["ABOUT", "PRODUCTS", "GALLERY", "360°", "CONTACT"].map((t) => <span key={t} className="text-[7px] font-mono tracking-widest text-slate-500 border border-slate-800 rounded-sm px-1.5 py-0.5">{t}</span>)}</div>
          <div className="space-y-1.5 mt-3">{[90, 70, 80].map((w) => <div key={w} className="h-1.5 bg-navy-800 rounded-full" style={{ width: `${w}%` }} />)}</div>
        </div>
      </div>
      <div className="w-20 bg-navy-900 border border-slate-700 rounded-xl overflow-hidden shadow-2xl shrink-0">
        <div className="w-8 h-1 bg-slate-700 rounded-full mx-auto mt-1.5" />
        <div className="p-2.5">
          <div className="h-14 rounded-sm bg-gradient-to-b from-navy-700 to-navy-800 border border-slate-700 flex items-end p-1.5"><p className="text-[6px] font-bold text-slate-200">YOUR COMPANY</p></div>
          <div className="space-y-1 mt-2">{[100, 80, 90].map((w) => <div key={w} className="h-1 bg-navy-800 rounded-full" style={{ width: `${w}%` }} />)}</div>
        </div>
      </div>
    </div>
  );
}

export default function MembershipAdvantage() {
  return (
    <div data-testid="advantage-page">
      {/* HEADER */}
      <section className="relative overflow-hidden border-b border-slate-800" data-testid="advantage-hero">
        <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_70%_20%,rgba(212,175,55,0.10),transparent_55%)]" />
        <div className="relative max-w-7xl mx-auto px-4 md:px-8 py-16 md:py-20">
          <p className="gold-kicker">10XGLOBAL Advisory — Connecting Business. Capital. Markets. Partners.</p>
          <h1 className="font-display text-3xl sm:text-4xl lg:text-5xl font-extrabold tracking-tight text-slate-100 mt-5 leading-tight">
            WHAT YOU GET AFTER REGISTRATION
            <span className="block mt-2 text-gold">YOUR MEMBERSHIP. YOUR ADVANTAGE.</span>
          </h1>
          <Link to="/secure-register" data-testid="advantage-register-top-btn" className="btn-gold mt-8">REGISTER NOW <ArrowRight size={16} /></Link>
        </div>
      </section>

      {/* 1 — CERTIFICATE */}
      <section className="max-w-7xl mx-auto px-4 md:px-8 py-20" data-testid="advantage-certificate">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          <div className="flex gap-6">
            <NumberBadge n="1" />
            <div>
              <h2 className="font-display text-xl sm:text-2xl font-bold tracking-tight text-slate-100 mb-6">MEMBERSHIP CERTIFICATE</h2>
              <Checklist items={CERT_POINTS} testid="certificate-checklist" />
            </div>
          </div>
          <div className="max-w-md mx-auto w-full"><CertificateMock /></div>
        </div>
      </section>

      {/* 2 — PROFILE */}
      <section className="border-y border-slate-800 bg-navy-900/40" data-testid="advantage-profile">
        <div className="max-w-7xl mx-auto px-4 md:px-8 py-20 grid lg:grid-cols-2 gap-12 items-center">
          <div className="flex gap-6">
            <NumberBadge n="2" />
            <div>
              <h2 className="font-display text-xl sm:text-2xl font-bold tracking-tight text-slate-100 mb-6">CREATE & PUBLISH COMPANY PROFILE</h2>
              <div className="grid sm:grid-cols-2 gap-x-8"><Checklist items={PROFILE_POINTS} testid="profile-checklist" /></div>
              <p className="mt-7 font-display font-bold text-gold tracking-wide flex items-center gap-2"><Megaphone size={16} /> BE SEEN. BE CONNECTED. BE CHOSEN.</p>
            </div>
          </div>
          <DeviceMocks />
        </div>
      </section>

      {/* 3 — WEBSITE */}
      <section className="max-w-7xl mx-auto px-4 md:px-8 py-20" data-testid="advantage-website">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          <div className="flex gap-6">
            <NumberBadge n="3" />
            <div>
              <h2 className="font-display text-xl sm:text-2xl font-bold tracking-tight text-slate-100 mb-6">UPLOAD YOUR WEBSITE</h2>
              <Checklist items={WEBSITE_POINTS} testid="website-checklist" />
            </div>
          </div>
          <div className="space-y-5">
            <div className="flex items-center bg-navy-900 border border-slate-700 rounded-sm px-4 py-3.5 gap-3" data-testid="website-url-bar">
              <Link2 size={16} className="text-slate-500 shrink-0" />
              <span className="text-sm text-slate-400 font-mono flex-1">https://www.yourwebsite.com</span>
              <Search size={16} className="text-gold shrink-0" />
            </div>
            <div className="card-surface hairline-gold p-6" data-testid="why-it-matters">
              <p className="text-[10px] font-mono uppercase tracking-widest text-gold mb-4">Why It Matters</p>
              <ul className="grid sm:grid-cols-2 gap-2.5">
                {WHY_IT_MATTERS.map((x) => <li key={x} className="flex items-center gap-2 text-xs text-slate-300"><Eye size={12} className="text-gold shrink-0" />{x}</li>)}
              </ul>
            </div>
          </div>
        </div>
      </section>

      {/* 4 — DISCOVERY */}
      <section className="border-y border-slate-800 bg-navy-900/40" data-testid="advantage-discovery">
        <div className="max-w-7xl mx-auto px-4 md:px-8 py-20">
          <div className="grid lg:grid-cols-[1fr_300px] gap-10 items-center">
            <div>
              <div className="flex gap-6 items-start">
                <NumberBadge n="4" />
                <h2 className="font-display text-xl sm:text-2xl font-bold tracking-tight text-slate-100">GET DISCOVERED. GET CONNECTED.<br />GROW GLOBALLY.</h2>
              </div>
              <div className="grid grid-cols-3 sm:grid-cols-4 md:grid-cols-7 gap-3 mt-10">
                {DISCOVERY_TILES.map(([Icon, label]) => (
                  <div key={label} className="card-surface p-4 text-center hover:border-gold/50 transition-colors" data-testid={`discovery-${label.toLowerCase()}`}>
                    <Icon size={22} className="text-gold mx-auto mb-2.5" strokeWidth={1.5} />
                    <p className="text-[9px] font-mono uppercase tracking-widest text-slate-300">{label}</p>
                  </div>
                ))}
              </div>
            </div>
            <div className="card-surface hairline-gold p-7 text-center" data-testid="one-membership-card">
              <Sparkles size={22} className="text-gold mx-auto mb-4" />
              <p className="font-display font-bold text-slate-100 leading-snug">ONE MEMBERSHIP.<br />ONE PROFILE.<br /><span className="text-gold">GLOBAL IMPACT.</span></p>
              <p className="text-[10px] font-mono uppercase tracking-widest text-slate-500 mt-4">All in one global platform.</p>
            </div>
          </div>
        </div>
      </section>

      {/* BOTTOM STRIP */}
      <section className="max-w-7xl mx-auto px-4 md:px-8 py-16" data-testid="advantage-strip">
        <div className="card-surface p-8 grid sm:grid-cols-2 lg:grid-cols-5 gap-8 items-center">
          {BOTTOM_STRIP.map(([Icon, title, desc]) => (
            <div key={title} className="flex items-start gap-3">
              <Icon size={26} className="text-gold shrink-0" strokeWidth={1.5} />
              <div>
                <p className="text-[10px] font-mono uppercase tracking-widest text-slate-100">{title}</p>
                <p className="text-[11px] text-slate-500 mt-1.5 leading-relaxed">{desc}</p>
              </div>
            </div>
          ))}
          <div className="lg:text-right">
            <p className="font-display font-black text-2xl text-slate-100">TOGETHER<br /><span className="text-gold">WE 10X.</span></p>
          </div>
        </div>
      </section>

      {/* FINAL CTA */}
      <section className="border-t border-slate-800" data-testid="advantage-final-cta">
        <div className="max-w-7xl mx-auto px-4 md:px-8 py-16 text-center">
          <h2 className="font-display text-2xl sm:text-3xl font-extrabold tracking-tight text-slate-100">LET'S BUILD GLOBAL CONNECTIONS<br />THAT CREATE REAL IMPACT.</h2>
          <p className="text-sm text-gold mt-3 italic">Welcome to the 10XGLOBAL family.</p>
          <Link to="/secure-register" data-testid="advantage-register-bottom-btn" className="btn-gold mt-8 !px-10 !py-4">REGISTER NOW <ArrowRight size={16} /></Link>
          <div className="flex flex-wrap justify-center gap-x-10 gap-y-3 mt-10 text-sm text-slate-400">
            <span className="flex items-center gap-2"><Globe size={15} className="text-gold" /> 10x-global.com</span>
            <span className="flex items-center gap-2"><Mail size={15} className="text-gold" /> rathod@10x-global.com</span>
          </div>
        </div>
      </section>
    </div>
  );
}
